import React, { useEffect, useState } from 'react'
import UserLayout from '../../../components/layouts/UserLayout'
import Loader from '../../../components/elements/Loader';
import { useParams } from 'react-router-dom';
import ArrowIcon from '../../../components/elements/icons/ArrowIcon';
import { authHeader } from '../../../utils';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { ERROR } from '../../../store/types';
import InlinePreloader from '../../../components/elements/InlinePreloader';

const AdmissionOffer = () => {
    const [admissionOffer, setAdmissionOffer] = useState(null);
    const [loading, setLoading] = useState(true);
    const { admissionOfferId } = useParams()
    const [processing, setProcessing] = useState(false);
    const dispatch = useDispatch()

    // const navigate = useNavigate()
    const [doc, setDoc] = useState(null);
    useEffect(() => {
        const fetchAdmission = async () => {
            try {
                const headers = authHeader()

                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admission-offers/${admissionOfferId}?expand=acceptanceFee,application`, { headers })            

                setAdmissionOffer(response.data.data)
                fetchDocument(response.data.data.offerLetter, response.data.data.application._id)
            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
                setLoading(false)
            }
        }
        const fetchDocument = async (documentId, applicationId) => {    
            try{
                const headers = authHeader()

                let requestUrl = `documents/read/application/${applicationId}/${documentId}`
                setLoading(true)
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${requestUrl}`, { headers })
        
                setDoc(response.data.data)
                setLoading(false)
            }
            catch(error){
                dispatch( {
                    type: ERROR,
                    error
                })
            }
        }
        //   fetchDocument()
        fetchAdmission()

        return () => {
        
        };
    }, [admissionOfferId, dispatch]);

    const initializePayment = async () => {
        try {
        const headers = authHeader()

        const paymentPayload = {
            fee: admissionOffer.acceptanceFee._id,
            paymentChannel: "ONLINE",
            application: admissionOffer.application._id,
            redirectUrl: `${window.location.origin}/user/verify-payment?admission-offer=${admissionOfferId}`
        }
        setProcessing(true)
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/payments/initialize-payment`, paymentPayload, { headers })           
        console.log(response.data)
        window.location.href = response.data.data.link

        setLoading(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
            dispatch({
                type: ERROR,
                error
            })
            setLoading(false)
        }
    }

    return (
        <UserLayout>
        {loading ? 
            <Loader />
        :
            <div className='mt-5 w-full xl:w-1/2 mx-auto bg-gray-100 px-8 py-12'>
                <div className='pb-12' dangerouslySetInnerHTML={{__html: doc.documentBody}} />

                <div className='bg-vcm-light-purple rounded-[8px] bg-opacity-10 border-opacity-50 border border-vcm-purple p-[15px]'>
                    <p className='tracking-[0.2em] uppercase mb-2'>acceptance fee - N{(admissionOffer?.acceptanceFee?.amount/100).toLocaleString()}</p>
                    <button onClick={()=>{initializePayment()}} className='p-3 bg-vcm-purple border border-vcm-purple text-purple-100 rounded-md mt-5 text-sm flex flex-row items-center gap-x-3 hover:text-vcm-purple hover:bg-vcm-light-purple transition duration-200'>
                        {!processing ? <>
                            Pay acceptance fee <ArrowIcon className={`w-4 h-4`} />
                        </> : 
                            <InlinePreloader />
                        }
                    </button>
                </div>

            </div>
        }
        </UserLayout>
    )
}

export default AdmissionOffer